import constructActionTypes from 'common/utils/constructActionTypes';

module.exports = constructActionTypes(
    {
        ADD_NODE_LOGIC_EFFECT: null,
        REMOVE_NODE_LOGIC_EFFECT: null,
        UPDATE_NODE_LOGIC_EFFECT: null,
        REPLICATE_FORM_NODE_LOGIC_EFFECT: null,
        REPLICATE_ADDITIONAL_FORM_NODE_LOGIC_EFFECT: null,
        UPDATE_MAX_GUEST_COUNT_LOGIC_EFFECT: null,
        ADD_MULTIPLE_NODE_LOGIC_EFFECT: null,
        CROSS_GROUP_EFFECTS: null,
        CREATE_MULTIPLE_ADD_LOGIC_EFFECT: null,
        REMOVE_MULTIPLE_NODE_LOGIC_EFFECT: null,
        ADD_FORM_TO_LIBRARY_EFFECT: null,
        FETCH_FORM_LIBRARY_LIST_EFFECT: null,
        APPLY_FORM_TO_EVENT_EFFECT: null,
        APPLY_FORM_WITH_FORM_ID_TO_EVENT_EFFECT: null,
        SEARCH_FORM: null,
        SAVE_FORM_LIBRARY_NAME_EFFECT: null,
        SAVE_FORM_AS_COPY_EFFECT: null,
        UPDATE_FORM_OWNERSHIP_EFFECT: null,
        GET_EVENT_THEME_COUNT_EFFECT: null,
    },
    '@effect/formBuilder',
);
